import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import '../../App.css'

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool,
};

const defaultProps = {
  topOuterDivider: false,
  topDivider: false,
};

const Footer = ({ className, topOuterDivider, topDivider, ...props }) => {
  const classes = classNames(
    "site-footer center-content-mobile",
    topOuterDivider && "has-top-divider",
    className
  );

  return (
    <footer {...props} className={classes}>
      <div className="container">
        <div
          className={classNames(
            "site-footer-inner",
            topDivider && "has-top-divider"
          )}
        >
          <center>
            <div className="footer-bottom text-xxs invert-order-desktop">
              <div>
                Made with <span role='img' aria-label='black-heart'>🖤</span> by <span className="text-nice">Adler Kesley</span>.
              </div>
            </div>
          </center>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
